/* eslint-disable indent */
/* eslint-disable operator-linebreak */
import { Divider, ListItemText, MenuItem, Typography } from "@mui/material";
import { EmptyGeneric, Loading } from "../../../components";
import {
  IPetItemResponse,
  IPrescriptionItemResponse,
} from "../../../services/Standard-of-care/standard-of-care.interface";
import React, { useEffect, useState } from "react";

import { GvCustomMenu } from "../../../styles/styledComponents";
import { IPrescriptionResponse } from "../../../services/prescription/prescription.interface";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import PrescriptionCard from "./PrescriptionCard";
import { usePrescription } from "../../../services/prescription/prescription.service";
import { userActivityLogger } from "../../../utils/mixpanel";

type IPrescription = {
  prescription: IPrescriptionItemResponse[];
  petData: IPetItemResponse;
};

const PrescriptionsContainer = (props: IPrescription) => {
  const { petData } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { getPrescriptionInfo, loading, prescription } = usePrescription();
  const [sortedPrescriptions, setSortedPrescriptions] = useState<IPrescriptionResponse[]>();
  const [selectedType, setselectedType] = useState<string>("All");

  useEffect(() => {
    if (petData?.id) {
      getPrescriptionInfo(petData?.id.toString());
    }
  }, [petData?.id]);

  useEffect(() => {
    if (prescription?.items?.length) {
      const sorted = [...prescription?.items].sort((a, b) => a?.state.localeCompare(b?.state));

      setSortedPrescriptions(sorted);
      userActivityLogger(MIXPANEL_EVENTS.PHARMACY_PRESCRIPTIONS_LOADED, {
        total_count: prescription.items.length,
        renewal_count: prescription.items.filter((item) => item.state === "Expired").length,
        source: "care",
      });
    }
  }, [prescription]);

  const filterByType =
    selectedType === "Expired"
      ? sortedPrescriptions?.filter((item) => item.state === "Expired")
      : selectedType === "Active"
        ? sortedPrescriptions?.filter((item) => item.state === "Active")
        : sortedPrescriptions;

  const handlePrescriptionChange = (value: string) => {
    setselectedType(value);
    handleClose();
  };

  const typeList = ["All", "Active", "Expired"];

  useEffect(() => {
    userActivityLogger(MIXPANEL_EVENTS.VISIT_PRESCRIPTION, { pet_name: petData?.name });
  }, []);

  return (
    <>
      {loading ? (
        <div className="h-1/2 flex flex-col justify-center items-center">
          <Loading />
        </div>
      ) : (
        <div className="h-full">
          <div className="flex justify-between mb-3">
            <Typography variant="h4" className="font-semibold">
              Prescriptions
            </Typography>

            <div
              className="flex gap-1 border border-gray-3 rounded-lg min-w-min items-center px-2 bg-white
             cursor-pointer"
              id="prescription-button"
              aria-haspopup="true"
              aria-controls={open ? "prescription-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              onClick={(e) => handleClick(e)}
            >
              <Typography variant="body1"> {selectedType} </Typography>
              <KeyboardArrowDownIcon />
            </div>

            <GvCustomMenu
              autoFocus={false}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              id="prescription-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{ "aria-labelledby": "prescription-button" }}
            >
              {typeList.map((year) => (
                <div key={year}>
                  <MenuItem onClick={() => handlePrescriptionChange(year)}>
                    <ListItemText>{year}</ListItemText>
                  </MenuItem>
                  <Divider className="w-full !m-0" />
                </div>
              ))}
            </GvCustomMenu>
          </div>
          {prescription?.items?.length ? (
            <div className="flex flex-col gap-3 h-full">
              <div className="h-full">
                {filterByType?.length ? (
                  filterByType?.map((item, i) => <PrescriptionCard key={item.id || i} prescription={item} />)
                ) : (
                  <div
                    className="h-full flex-grow flex flex-col justify-center items-center
                   max-h-[50vh] 4xl:max-h-[35vh]
                   pt-11 sm:pt-0 sm:max-w-lg sm:mx-auto"
                  >
                    <EmptyGeneric
                      nonTitle={false}
                      image="/assets/icons/Prescriptions.svg"
                      title="No Prescriptions Found"
                      description={`It looks like you don’t have any prescriptions.
                                    If this isn’t the case, please contact your local GoodVets hospital.`}
                    />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className="h-full flex-grow flex flex-col justify-center items-center max-h-[50vh] 4xl:max-h-[35vh]
                   pt-11 sm:pt-0 sm:max-w-lg sm:mx-auto"
            >
              <EmptyGeneric
                nonTitle={false}
                image="/assets/icons/Prescriptions.svg"
                title="No Prescriptions Found"
                imageClassName="h-[160px]"
                description={`We do not have any prescriptions on file for your pet.
               It may take up to 24 hours after a visit for any new prescriptions to be added to your account.`}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default PrescriptionsContainer;
